import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { modulosWeb } from '../nucleo/modulos-web';
import { definirIdiomaFormato, type Idioma } from '../nucleo/formato';
import { assinarDiscreto } from '../nucleo/discreto';
import { acessibilidadeEn } from './acessibilidade-en';
import { assistentesEn } from './assistentes-en';
import { assistentesEs } from './assistentes-es';
import { assistentesPt } from './assistentes-pt';
import { acessibilidadeEs } from './acessibilidade-es';
import { acessibilidadePt } from './acessibilidade-pt';
import { discretoEn } from './discreto-en';
import { discretoEs } from './discreto-es';
import { discretoPt } from './discreto-pt';
import { en } from './en';
import { notificacoesEn } from './notificacoes-en';
import { notificacoesEs } from './notificacoes-es';
import { notificacoesPt } from './notificacoes-pt';
import { es } from './es';
import { ajustarPlural, type ResolvedorPlural } from './plural';
import { pt } from './pt';

/** F8: dicionário do núcleo (namespace `nucleo`) mais um namespace por módulo (`<slug>`). */
const recursos: Record<Idioma, Record<string, Record<string, unknown>>> = {
  pt: { nucleo: { ...pt, ...acessibilidadePt, ...discretoPt, ...notificacoesPt, assistentes: assistentesPt } },
  en: { nucleo: { ...en, ...acessibilidadeEn, ...discretoEn, ...notificacoesEn, assistentes: assistentesEn } },
  es: { nucleo: { ...es, ...acessibilidadeEs, ...discretoEs, ...notificacoesEs, assistentes: assistentesEs } },
};
for (const m of modulosWeb) {
  for (const idioma of ['pt', 'en', 'es'] as const) recursos[idioma][m.slug] = m.i18n[idioma];
}

function idiomaInicial(): Idioma {
  try {
    const salvo = localStorage.getItem('malgoos.idioma');
    if (salvo === 'pt' || salvo === 'en' || salvo === 'es') return salvo;
  } catch {
    /* sem storage */
  }
  const nav = navigator.language.slice(0, 2);
  return nav === 'en' || nav === 'es' ? nav : 'pt';
}

const inicial = idiomaInicial();
definirIdiomaFormato(inicial);
// r9 visual B4: o <html lang> sai do idioma inicial (salvo ou do navegador) já no primeiro acesso, não só na troca.
const langHtml = (i: Idioma) => (i === 'pt' ? 'pt-BR' : i);
if (typeof document !== 'undefined') document.documentElement.lang = langHtml(inicial);

void i18n.use(initReactI18next).init({
  resources: recursos,
  lng: inicial,
  fallbackLng: 'pt',
  defaultNS: 'nucleo',
  ns: ['nucleo', ...modulosWeb.map((m) => m.slug)],
  interpolation: { escapeValue: false },
  returnNull: false,
  // Modo discreto: a troca chega como o evento `discreto` e renderiza de novo todo componente com `useTranslation`. O `t` muda
  // de identidade, então os useMemo e useCallback que dependem dele também refazem os textos formatados.
  react: { bindI18n: 'languageChanged discreto' },
});

assinarDiscreto(() => i18n.emit('discreto'));

/** Em português do Brasil o CLDR trata o zero como singular ("0 documento"); na tela lemos "0 documentos". */
ajustarPlural(i18n.services.pluralResolver as ResolvedorPlural);

export function trocarIdioma(i: Idioma) {
  definirIdiomaFormato(i);
  try {
    localStorage.setItem('malgoos.idioma', i);
  } catch {
    /* sem storage */
  }
  document.documentElement.lang = langHtml(i);
  return i18n.changeLanguage(i);
}

export default i18n;
